export const isSsr = () => typeof window === "undefined";
export const isMWeb = () => typeof window === "object";
export const isClientRender = () => typeof window === "object";
